// @flow

import type {OrderItem} from './order-item'

export type OrderPurchaseItem = {
  id: ?string,
  payInTerms: ?boolean,
  nrOfTerms: ?number
}

const buildOrderPurchaseItem = function (orderItem: OrderItem): OrderPurchaseItem {
  return {
    id: orderItem.id,
    payInTerms: orderItem.payInTerms,
    nrOfTerms: orderItem.nrOfTerms
  }
}

export {
  buildOrderPurchaseItem
}



// WEBPACK FOOTER //
// ./src/types/order-purchase-item.js